import type { LocationQuery } from 'vue-router'

/** Tabs on Settings › Integrations, addressed by `?tab=`. A missing or unknown tab means `email`. */
export const INTEGRATION_TABS = ['email', 'analytics', 'apps', 'webhooks'] as const
export type IntegrationTab = (typeof INTEGRATION_TABS)[number]

export const isIntegrationTab = (value: unknown): value is IntegrationTab =>
  typeof value === 'string' && (INTEGRATION_TABS as readonly string[]).includes(value)

/**
 * Legacy `?tab=other` links (analytics tools, apps, webhook secret) land on
 * Analytics, the first of them.
 */
export function integrationTabFromLegacyQuery(query: LocationQuery): LocationQuery {
  const { tab, ...rest } = query
  return tab === 'other' ? { ...rest, tab: 'analytics' } : query
}
